import { atom } from 'recoil';

export const userInfo = atom({
  key: 'userInfo',
  default: {
    isLoggedIn: true,
    name: null,
    type: null,
    hasReadTooltip: false,
  },
});
